export const CookieName = "isAuthenticated";
export const CookieValue = "TRUE";

export const EmergencyCookieName = "isEmergency"

export const EmergencyCookieValue = "TRUE"

export const isAuthenticated = (value?:string) => {
    return value === CookieValue;
}

export const isEmergency = (value?: string) => {
    return value === CookieValue;
}